export enum ECalendarEntryType {    
    Holiday,
    Workday
}